import { gql } from '@apollo/client'

export const NOTIFICATIONS_TOTAL_COUNT_QUERY = gql`
  query notificationsTotalCount($read: Boolean) {
    notificationsTotalCount(read: $read)
  }
`
